import { useContext, useEffect, useMemo, useState } from "react";
import { TranslationContext } from "../../shared/providers/translation/translation.provider";
import StoreIOS from "../../shared/assets/imgs/store_ios.svg";
import StoreAndroid from "../../shared/assets/imgs/store_android.svg";
import { getAbout } from "../../shared/services/about.service";
import { useGetAbout } from "../../shared/hooks/useAbout";
import { LoadingContext } from "../../shared/providers/loading/loading.provider";
import { markdownToHtml } from "../../shared/helpers/utils";
import { Player } from "../../components/Player/Player";

function AboutPage() {
    const { translate, lang } = useContext(TranslationContext);
    const { setIsLoading } = useContext(LoadingContext);

    const { data, isLoading } = useGetAbout(lang ?? "");
    const page = useMemo(() => {
        if (!data?.success || !data?.data) return null;
        return data.data;
    }, [data]);

    useEffect(() => { setIsLoading(isLoading) }, [isLoading]);

    return (
        <div className="row px-md-31 px-1 pb-5">
            <div className="col-12">
                <section className="about">
                    <h1 className="text-h2-smbd mb-2">
                        {translate("nav.about_prosperh", "What is PROSPERH")}
                    </h1>
                    <div className="d-flex flex-column gap-4">

                        {page?.videoUrl && <Player videoSrc={page.videoUrl} />}

                        <article className="content p-22">
                            {page?.content && <div className="text-bd1-rg color-neutrals-black rich_text" dangerouslySetInnerHTML={{ __html: markdownToHtml(page?.content) }}>
                            </div>}
                            {(page?.appstore_android || page?.appstore_ios) && <><h2 className="text-h3-md mb-1 mt-3">
                                {translate("about.download_app", "Download the app")}
                            </h2>
                                <ul className="d-flex gap-12">
                                    {page?.appstore_android && <li>
                                        <a href={page?.appstore_android}>
                                            <img src={StoreAndroid} alt="Play Store" />
                                        </a>
                                    </li>}
                                    {page?.appstore_ios && <li>
                                        <a href={page?.appstore_ios}>
                                            <img src={StoreIOS} alt="App Store" />
                                        </a>
                                    </li>}
                                </ul></>}
                        </article>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default AboutPage;
